export const colors = {
    green: '#AFD000',
    lightGreen: '#B6CE38',
    blue: '#003274',
    darkBlue: '#00132C'
};
